// export const host = 'http://localhost:3001'
export const host = process.env.REACT_APP_API_HOST || 'http://52.1.94.148:3334' //'http://192.168.1.15'
